<div class="change-password-container">
  <img src="assets/images/logo_etrasa.png">

  <div class="form-container">
    <form (ngSubmit)="changePassword()" #form="ngForm">
      <h1 class="custom-title">Cambio de contraseña</h1>

      <div class="inputs-container">
        <input [type]="inputType" [(ngModel)]="newPasswordForm.oldPass" name="oldPass" id="oldPass" class="input" placeholder="Contraseña actual" maxlength="50"
          #oldPassInput (keydown.enter)="newPassInput.focus(); $event.preventDefault()">

        <input [type]="inputType" [(ngModel)]="newPasswordForm.newPass" name="newPass" id="newPass" class="input" placeholder="Nueva contraseña" maxlength="50"
          #newPassInput (keydown.enter)="repeatNewPassInput.focus(); $event.preventDefault()">

        <input [type]="inputType" [(ngModel)]="newPasswordForm.repeatNewPass" name="repeatNewPass" id="repeatNewPass" class="input" placeholder="Repite la nueva contraseña" maxlength="50"
          #repeatNewPassInput (keydown.enter)="(!!this.newPasswordForm.oldPass && !!this.newPasswordForm.newPass && !!this.newPasswordForm.repeatNewPass) ? changePassword() : null; $event.preventDefault()">
      </div>

      <p (click)="showPasswords()" class="show-password">{{inputType === 'password' ? 'Mostrar' : 'Ocultar'}} contraseñas</p>

      @if (showErrorMessage) {
        <p class="error-message">{{errorMessage}}</p>
      }

      <p class="change-password-info">El cambio de contraseña afectará a todas las aplicaciones de Etrasa de tu usuario.</p>

      <div class="button-container">
        <button (click)="logout()">Cancelar</button>

        <button type="submit" [disabled]="!this.newPasswordForm.oldPass || !this.newPasswordForm.newPass || !this.newPasswordForm.repeatNewPass">Aceptar</button>
      </div>
    </form>
  </div>
</div>